import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { MatInput } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatDividerModule } from '@angular/material/divider'
import { EmployeeStatusService } from '../../../core/services/employee/employee-status/employee-status.service'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { HabitsService } from '../../../core/services/employee/employee-role/habits.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {NgxMaskDirective} from 'ngx-mask';
import {MunicipalityService} from '../../../core/services/municipality/municipality/municipality.service';
import {MessageService} from '../../../core/services/message/message/message.service';
import {ContentTypeService} from '../../../core/services/content-type/document-type/content-type.service';
import {ContentSugestionService} from '../../../core/services/content-sugestion/message/content-sugestion.service';

@Component({
  selector: 'content-sugestion-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    MatOption,
    MatSelect,
    MatDividerModule,
    MatSlideToggle,
    NgxMaskDirective,
  ],
  templateUrl: './content-sugestion-create.component.html',
  styleUrl: './content-sugestion-create.component.scss',
  providers: [
    ViaCepService,
    EmployeeStatusService,
    EmployeeService,
    HabitsService,
    AddressTypeService,
  ],
  standalone: true,
})
export class ContentSugestionCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private contentTypeService: ContentTypeService,
    private locationService: ContentSugestionService,
    private snackbar: SnackbarCustomService,
    private viaCepService: ViaCepService,
    private dialogRef: MatDialogRef<ContentSugestionCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  @Output() responseCreate = new EventEmitter()

  form: FormGroup = new FormGroup({})
  listUseTypes: any[] = []
  loading: boolean = false

  ngOnInit(): void {
    this.createForm()
    this.useTypes()
  }
  useTypes(){
    this.contentTypeService.listContentType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listUseTypes = response.data
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }
  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      descricao: this.form.get('description')?.value,
      titulo: this.form.get('title')?.value,
      subtitulo: this.form.get('subtitle')?.value,
      tipo_conteudo: this.form.get('contentType')?.value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      title: ['', [Validators.required]],
      subtitle: ['', [Validators.required]],
      contentType: [null, [Validators.required]],
      description: ['', [Validators.required]],
    })
  }
  createLocation() {
    this.loading = true
    this.locationService.createContentSugestion(this.createModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }
}
